import { useState, useEffect, useMemo } from "react";
import { useRawTable } from "../../hooks";

export default function Module_HealthCheckup_QuestionnaireYearAndMonthClosedCount({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const [categoryData, setCategoryData] = useState({});
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      categoryData,
    }),
    [moduleData, categoryData]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    setTbData({
      raw: apiData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
